import { PlaceUserDto, PublicServerPlaceEvent } from 'gleblu-socket-api';
import { put, takeEvery } from 'redux-saga/effects';

import PlaceUser from '../../../models/interfaces/PlaceUser';
import {
  employeeInvitationFetched,
  employeeInvitationFetchFailed,
  fetchEmployeeInvitation,
  FetchEmployeeInvitationActionType,
} from '../../actions/registration/fetchEmployeeInvitation';
import getPublicResponse from '../getPublicResponse';

function* fetchEmployeeInvitationSaga({ payload }: FetchEmployeeInvitationActionType) {
  const { token } = payload;
  const response = yield getPublicResponse(PublicServerPlaceEvent.getEmployeeInvitation, {
    token,
  });
  const { error } = response;
  if (error) {
    const action = employeeInvitationFetchFailed({ token });
    yield put(action);
  } else {
    const { errorType, placeUser: placeUserDto } = response;
    const placeUser: PlaceUser = placeUserDto as PlaceUserDto;
    const action = employeeInvitationFetched({ token, errorType, placeUser });
    yield put(action);
  }
}

export default function* watchFetchEmployeeInvitation() {
  yield takeEvery(fetchEmployeeInvitation, fetchEmployeeInvitationSaga);
}
